import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import Cookies from 'js-cookie';
import { Course } from '../../database.schema';

type CourseData = {
  course: Course;
  courseIndex: number;
};

const mutateCourse = async (courseData: CourseData): Promise<CourseData> => {
  const authToken = Cookies.get('token');
  var dbDNS = `https://golf-tour-462cf-default-rtdb.europe-west1.firebasedatabase.app/courses/${courseData.courseIndex}/.json?auth=${authToken}`;
  if (process.env.REACT_APP_MODE === 'dev') {
    dbDNS = `http://127.0.0.1:9000/courses/${courseData.courseIndex}/.json?ns=golf-tour-462cf-default-rtdb&auth=${authToken}`;
  }
  const response = await fetch(dbDNS, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ ...courseData.course }),
  });

  if (!response.ok) {
    throw new Error('Network response was not ok');
  }
  return await response.json();
};

export const useCourseMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: mutateCourse,
    onSuccess: () => {
      // Invalidate and refetch
      queryClient.invalidateQueries({ queryKey: ['all-data'] });
    },
    onError: (error) => {
      console.log('error', error);
    },
  });
};
